export const percentFilter = (value: number) => {
  const convertedValue = Number(value) * 100;
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 0
      })}%`) ||
    "0%"
  )
}
export const percentFilterDecimal = (value: number) => {
  const convertedValue = Number(value) * 100;
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 2
      })}%`) ||
    "0%"
  )
}

export const percentAsIsFilter = (value: number) => {
  const convertedValue = Number(value);
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 0
      })}%`) ||
    "0%"
  )
}
